import AxiosInterceptor from "../utils/AxiosInterceptor";
let BASE = "/user";
const userService = {
  getAll: (value) => AxiosInterceptor().post(`${BASE}/getAllUser`, value),
  edit: (value) => AxiosInterceptor().post(`${BASE}/updateUser`, value),
  getById: (id) => AxiosInterceptor().get(`${BASE}/getOneUser/${id.id}`),
  add: (value) => AxiosInterceptor().post(`${BASE}/addUser`, value),
  delete: (value) => AxiosInterceptor().post(`${BASE}/deleteUser`, value),
  changeStatus: (value) =>
    AxiosInterceptor().post(`${BASE}/changeStatus`, value),
};

export default userService;
